<template>
  <Content :title="'Órdenes de Servicio'">
    <Spinner v-if="loading.view"></Spinner>
    <template v-else>
      <Card icon="fa fa-filter" title="Filtros">
        <div class="row mb-2">
          <div class="col-lg-2">
            <div class="form-group">
              <label for="" class="form-label">
                Servicio:
              </label>
              <InputSelect v-model="form.servicio" :options="serviciosFiltro" label="nombre" :disabled="hayEditables"></InputSelect>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="form-group">
              <label for="" class="form-label">
                Fecha:
              </label>
              <InputDatepicker v-model="form.fecha" :editable="false" :disabled="hayEditables"></InputDatepicker>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="form-group">
              <label for="" class="form-label">
                Idioma:
              </label>
              <InputSelect v-model="form.idioma" :options="idiomasOpciones" :disabled="hayEditables"></InputSelect>
            </div>
          </div>
        </div>
        <div class="w-100"></div>
        <ul class="list-inline mb-0">
          <li class="list-inline-item"><strong>Nro. de Órdenes:</strong> {{ resumen.nroOrdenes }}</li>
          <li class="list-inline-item"><strong>Registros:</strong> {{ resumen.registros }}</li>
          <li class="list-inline-item"><strong>PAX:</strong> {{ resumen.PAX }}</li>
          <li class="list-inline-item"><strong>CHD:</strong> {{ resumen.CHD }}</li>
          <li class="list-inline-item"><strong>Total:</strong> {{ resumen.total }}</li>
          <li class="list-inline-item"><strong>Español:</strong> {{ resumen.esp }}</li>
          <li class="list-inline-item"><strong>Inglés:</strong> {{ resumen.ing }}</li>
        </ul>
      </Card>
      <Card title="Órdenes de Servicio" :bodyClass="'p-0'">
        <template #toolbar>
          <Button class="btn-sm" :variant="'outline-secondary'" :disabled="loading.reporte || !paginacion.total || hayEditables" @click="onPrint">
            {{ loading.reporte ? "Preparando..." : "Imprimir" }}
          </Button>
        </template>
        <OrdenesDeServicioTable :rows="list" @store="onStore"></OrdenesDeServicioTable>
        <BPagination
          v-if="paginacion.total > paginacion.porPagina"
          :value="paginacion.pagina"
          :total-rows="paginacion.total"
          :per-page="paginacion.porPagina"
          :disabled="loading.ordenes || hayEditables"
          first-number
          last-number
          :limit="6"
          align="center"
          class="mt-5"
          @input="onCambiarPagina"
        ></BPagination>
      </Card>
      <OrdenDeServicioLiquidarModal
        v-if="containers.showOrdenDeServicioLiquidarModal"
        :modal-item="containers.modalItem"
        @hide="containers.showOrdenDeServicioLiquidarModal = false"
      ></OrdenDeServicioLiquidarModal>
    </template>
  </Content>
</template>

<script>
import { BPagination } from "bootstrap-vue";
import { mapGetters, mapState } from "vuex";

import Button from "../../shared/components/Button.vue";
import OrdenDeServicioLiquidarModal from "../components/OrdenDeServicioLiquidarModal.vue";
import Spinner from "../../shared/components/Spinner.vue";
import OrdenesDeServicioTable from "../components/OrdenesDeServicioTable.vue";
import InputDatepicker from "../../shared/components/InputDatepicker.vue";
import InputSelect from "../../shared/components/InputSelect.vue";
import Card from "../../shared/components/Card.vue";
import Content from "../../shared/components/Content.vue";
import { debounce } from "../../shared/helpers";
import pdfOrdenes from "../../../pdfs/pdfOrdenes";

export default {
  components: { Content, Card, InputSelect, InputDatepicker, OrdenesDeServicioTable, Spinner, OrdenDeServicioLiquidarModal, Button, BPagination },
  data() {
    return {
      loading: {
        view: true,
        ordenes: false,
        reporte: false,
      },
      form: {
        servicio: null,
        fecha: "",
        idioma: "Todos",
      },
      paginacion: {
        pagina: 1,
        porPagina: 50,
        total: 0,
        ultimaPagina: 0,
      },
      resumen: {
        nroOrdenes: 0,
        registros: 0,
        PAX: 0,
        CHD: 0,
        total: 0,
        esp: 0,
        ing: 0,
      },
      inicializado: false,
      solicitudOrdenes: 0,
      containers: {
        modalItem: null,
        showOrdenDeServicioLiquidarModal: false,
      },
    };
  },
  computed: {
    idiomasOpciones() {
      return ["Todos", ...this.idiomasFiltro];
    },
    ...mapState("ordenesDeServicio", ["list", "serviciosFiltro", "idiomasFiltro"]),
    ...mapGetters("ordenesDeServicio", ["hayEditables"]),
  },
  watch: {
    form: {
      deep: true,
      handler() {
        if (!this.inicializado) return;

        this.solicitudOrdenes += 1;
        this.onCambiarFiltros();
      },
    },
  },
  async created() {
    try {
      await this.cargarFiltros();
      this.aplicarFiltrosRuta();
      await this.cargarOrdenes();
    } catch (error) {
      console.error(error?.response || error);
    } finally {
      this.inicializado = true;
      this.loading.view = false;
    }
  },
  mounted() {
    const vm = this;
    vm.$root.$on("show:ordenDeServicio:liquidar", (item) => {
      vm.containers.modalItem = item;
      vm.containers.showOrdenDeServicioLiquidarModal = true;
    });
  },
  methods: {
    async cargarFiltros() {
      const response = await this.axios.get("/ordenes/filtros");
      this.$store.commit("ordenesDeServicio/loadContainers", response.data.content);
    },
    aplicarFiltrosRuta() {
      if (this.$route.query.fecha) {
        this.form.fecha = this.$route.query.fecha;
      }

      if (this.$route.query.servicio) {
        this.form.servicio = this.serviciosFiltro.find((item) => item.nombre == this.$route.query.servicio) || null;
      }
    },
    parametrosFiltros(form = this.form) {
      const parametros = {};

      if (form.servicio?.idServicio) {
        parametros.idServicio = form.servicio.idServicio;
      }

      if (form.fecha) {
        parametros.fecha = form.fecha;
      }

      if (form.idioma && form.idioma != "Todos") {
        parametros.idioma = form.idioma;
      }

      return parametros;
    },
    parametrosOrdenes() {
      return {
        ...this.parametrosFiltros(),
        pagina: this.paginacion.pagina,
        porPagina: this.paginacion.porPagina,
      };
    },
    prepararOrden(item) {
      return {
        ...item,
        isNew: false,
        isEdit: false,
        tempFecha: "",
        tempServicio: null,
        tempHoraSalida: "",
        tempVehiculo: null,
        tempConductor: null,
        tempOtroConductor: "",
        tempContacto: "",
        tempGuia: null,
        tempAsistente: null,
        tempTransfer: "",
        tempObservacion: "",
        tempAwanacancha: false,
      };
    },
    async cargarOrdenes() {
      const solicitud = ++this.solicitudOrdenes;
      this.loading.ordenes = true;

      try {
        const response = await this.axios.get("/ordenes", {
          params: this.parametrosOrdenes(),
        });

        if (solicitud !== this.solicitudOrdenes) return;

        const ordenes = response.data.content.ordenes.map((item) => this.prepararOrden(item));
        const paginacion = response.data.paginacion;

        if (!ordenes.length && this.paginacion.pagina > 1 && paginacion.ultimaPagina < this.paginacion.pagina) {
          this.paginacion.pagina = Math.max(1, paginacion.ultimaPagina);
          await this.cargarOrdenes();
          return;
        }

        this.$store.commit("ordenesDeServicio/updateList", ordenes);
        this.paginacion = paginacion;
        this.resumen = response.data.resumen;
      } catch (error) {
        if (solicitud === this.solicitudOrdenes) {
          console.error(error?.response || error);
        }
      } finally {
        if (solicitud === this.solicitudOrdenes) {
          this.loading.ordenes = false;
        }
      }
    },
    onCambiarFiltros: debounce(function() {
      if (this.hayEditables) return;

      this.paginacion.pagina = 1;
      this.cargarOrdenes();
    }, 400),
    onCambiarPagina(pagina) {
      if (pagina === this.paginacion.pagina || this.hayEditables) return;

      this.paginacion.pagina = pagina;
      this.cargarOrdenes();
    },
    async onStore() {
      await this.cargarOrdenes();
    },
    async onPrint() {
      if (this.loading.reporte || !this.paginacion.total || this.hayEditables) return;

      const form = {
        servicio: this.form.servicio,
        fecha: this.form.fecha,
        idioma: this.form.idioma,
      };

      this.loading.reporte = true;

      try {
        const response = await this.axios.get("/ordenes/reporte", {
          params: this.parametrosFiltros(form),
        });
        const ordenesReporte = response.data.content.ordenes;

        if (!ordenesReporte.length) {
          this.$toast.fire("", "No hay órdenes para imprimir", "warning");
          return;
        }

        const ordenes = ordenesReporte.map((item) => ({
          ...item,
          fecha: this.$options.filters.date(item.fecha),
          horaSalida: this.$options.filters.date(item.horaSalida, "HH:mm:ss", "HH:mm"),
          conductor: item.conductor || item.otroConductor || "",
          contactoConductor: item.contactoConductor || "",
        }));
        const resumen = {
          ...response.data.resumen,
          observaciones: ordenesReporte.filter((item) => (item.observacion || "").trim()),
        };

        pdfOrdenes({
          ordenes,
          resumen,
          servicio: form.servicio?.nombre || "",
          fecha: this.$options.filters.date(form.fecha),
          idioma: form.idioma || "",
          userMark: this.$store.state.user,
          dateMark: this.$dayjs().format("DD-MM-YY HH:mm"),
        });
      } catch (error) {
        console.error(error?.response || error);
        this.$toast.fire("", error?.response?.data?.message || "No fue posible preparar el reporte", "error");
      } finally {
        this.loading.reporte = false;
      }
    },
  },
};
</script>

<style></style>
